import { TextField, ComboBox, Dropdown, } from '@fluentui/react';
import { WithInstructionsAfterLabel } from './WithInstructionsAfterLabel';
/**
 * An instance of the FluentUI `ComboBox` component with a instructions
 * inserted between the label and the field itself.
 */
export const ComboBoxWithInstructions = WithInstructionsAfterLabel(ComboBox);
/**
 * An instance of the FluentUI `Dropdown` component with a instructions
 * inserted between the label and the field itself.
 */
export const DropdownWithInstructions = WithInstructionsAfterLabel(Dropdown);
/**
 * An instance of the FluentUI `TextField` component with a instructions
 * inserted between the label and the field itself.
 */
export const TextFieldWithInstructions = WithInstructionsAfterLabel(TextField);
